import { render, staticRenderFns } from "./NomePersonalizzato.vue?vue&type=template&id=ba58221e&"
import script from "./NomePersonalizzato.vue?vue&type=script&lang=js&"
export * from "./NomePersonalizzato.vue?vue&type=script&lang=js&"
import style0 from "./NomePersonalizzato.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports